import React from 'react';
import { Link } from "react-router-dom";
import {
	Card,
	Input,
	Button,
	Table,
	Modal,
	message,
	Alert,
	Tag,
	Tooltip,
	Typography,
	Pagination,
} from 'antd';
import {
	SearchOutlined,
	PlusOutlined,
	FormOutlined,
	CloseSquareOutlined,
	ExclamationCircleOutlined,
	DiffOutlined,
	RedoOutlined,
	ClusterOutlined,
	NumberOutlined,
	UndoOutlined,
} from '@ant-design/icons';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
} from "../../store/actions";

import Config from '../../Config';
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Data Jenis Kendaraan',
	apiUrl: { data: 'master/api/jenis/kendaraan/' },
	pageUrl: { form: '/admin/jenis-kendaraan/form/' },
	breadCrumb: [
		<span><DiffOutlined /> Master</span>,
		'Jenis Kendaraan',
	],
};

const config = new Config();

class DataJenisKendaraan extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			errMsg: '',
			errTitle: '',
			loadingData: false,
			loadingButton: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			searchText: '',
			dataSource: [],
			isMobile: window.innerWidth <= 768,
		};
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	showRestoreConfirm(id) {
		Modal.confirm({
			title: 'Aktifkan Jenis Kendaraan',
			icon: <UndoOutlined style={{ color: '#52c41a' }} />,
			content: 'Data jenis kendaraan akan diaktifkan kembali.',
			okText: 'Aktifkan',
			okButtonProps: { style: { background: '#52c41a', borderColor: '#52c41a' } },
			cancelText: 'Batal',
			onOk: () => this.prosesRestore(id),
		});
	}

	prosesRestore(id) {
		message.loading({ content: 'Mengaktifkan...', key: 'toast' });
		this.props.ajaxHandler('post', configClass.apiUrl.data + id + '/restore/', {}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Data jenis kendaraan berhasil diaktifkan kembali', duration: 2, key: 'toast' });
					this.getData();
				} else {
					message.error({ content: 'Gagal mengaktifkan data', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	showDeleteConfirm(id) {
		Modal.confirm({
			title: 'Nonaktifkan Jenis Kendaraan',
			icon: <ExclamationCircleOutlined />,
			content: 'Data jenis kendaraan akan dinonaktifkan. Data tetap tersimpan dan dapat diaktifkan kembali.',
			okText: 'Nonaktifkan',
			okType: 'danger',
			cancelText: 'Batal',
			onOk: () => this.prosesHapus(id),
		});
	}

	prosesHapus(id) {
		message.loading({ content: 'Menonaktifkan...', key: 'toast' });
		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				this.setState({ loadingButton: false });
				if (this.props.isSuccess) {
					message.success({ content: 'Data jenis kendaraan berhasil dinonaktifkan', duration: 2, key: 'toast' });
					this.getData();
				} else {
					const errTitle = 'Gagal menonaktifkan data';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ errTitle, errMsg: this.props.responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	async getData(limit = this.state.pagination.pageSize, offset = 0, search = this.state.searchText) {
		this.setState({ loadingData: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + '?limit=' + limit + '&offset=' + offset + '&search=' + search + '&include_deleted=true')
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					this.setState(prev => ({
						dataSource: data.results,
						pagination: { ...prev.pagination, total: data.count },
					}));
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => {
			this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
			this.getData(this.state.pagination.pageSize, 0, val);
		}, 400);
	};

	handleTableChange = (pagination) => {
		this.setState({
			pagination: { ...this.state.pagination, pageSize: pagination.pageSize, current: pagination.current },
		});
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
	};

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize);
	};

	_rekeningCell(val) {
		if (!val) return <Text type="secondary" style={{ fontSize: 11 }}>—</Text>;
		return <Text style={{ fontSize: 11, fontFamily: 'monospace', color: '#444' }}>{val}</Text>;
	}

	_buildColumns() {
		return [
			{
				title: 'No',
				key: 'no',
				width: 50,
				align: 'center',
				render: (_, __, index) => {
					const { pagination } = this.state;
					return <Text style={{ fontSize: 12, color: '#888' }}>{(pagination.current - 1) * pagination.pageSize + index + 1}</Text>;
				},
			},
			{
				title: 'Nama Jenis',
				dataIndex: 'nama',
				key: 'nama',
				width: 180,
				render: (value) => (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						<div style={{
							width: 34, height: 34, borderRadius: 8,
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
						}}>
							<ClusterOutlined style={{ color: '#fff', fontSize: 15 }} />
						</div>
						<div style={{ fontWeight: 600, fontSize: 13, color: '#222' }}>{value || '—'}</div>
					</div>
				),
			},
			{
				title: 'Kode',
				dataIndex: 'kode',
				key: 'kode',
				width: 80,
				align: 'center',
				render: (val) => (
					<Tag style={{
						borderRadius: 20, fontWeight: 600, fontSize: 11,
						background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a', letterSpacing: 1,
					}}>
						{val || '—'}
					</Tag>
				),
			},
			{
				title: 'Huruf',
				dataIndex: 'huruf',
				key: 'huruf',
				width: 70,
				align: 'center',
				render: (val) => (
					<Tag style={{
						borderRadius: 20, fontWeight: 600, fontSize: 11,
						background: '#f0f5ff', borderColor: '#adc6ff', color: '#2f54eb',
					}}>
						{val || '—'}
					</Tag>
				),
			},
			{
				title: 'Roda',
				dataIndex: 'roda',
				key: 'roda',
				width: 65,
				align: 'center',
				render: (val) => <Text style={{ fontSize: 13, fontWeight: 500 }}>{val || '—'}</Text>,
			},
			{
				title: 'Plat Kuning',
				dataIndex: 'plat_kuning',
				key: 'plat_kuning',
				width: 90,
				align: 'center',
				render: (val) => (
					<Tag color="orange" style={{ borderRadius: 20, fontWeight: 600, fontSize: 11 }}>
						{val != null ? val + ' %' : '—'}
					</Tag>
				),
			},
			{
				title: 'Rek. BBNKB',
				dataIndex: 'akun_bbnkb',
				key: 'akun_bbnkb',
				width: 120,
				align: 'center',
				render: this._rekeningCell,
			},
			{
				title: 'Rek. Denda BBNKB',
				dataIndex: 'akun_denda_bbnkb',
				key: 'akun_denda_bbnkb',
				width: 140,
				align: 'center',
				render: this._rekeningCell,
			},
			{
				title: 'Rek. PKB',
				dataIndex: 'akun_pkb',
				key: 'akun_pkb',
				width: 120,
				align: 'center',
				render: this._rekeningCell,
			},
			{
				title: 'Rek. Denda PKB',
				dataIndex: 'akun_denda_pkb',
				key: 'akun_denda_pkb',
				width: 130,
				align: 'center',
				render: this._rekeningCell,
			},
			{
				title: 'Rek. SP3',
				dataIndex: 'akun_sp3',
				key: 'akun_sp3',
				width: 120,
				align: 'center',
				render: this._rekeningCell,
			},
			{
				title: 'Rek. SP3 Mutasi',
				dataIndex: 'akun_sp3_mutasi',
				key: 'akun_sp3_mutasi',
				width: 130,
				align: 'center',
				render: this._rekeningCell,
			},
			{
				title: 'Status',
				dataIndex: 'deleted_at',
				key: 'status',
				width: 110,
				align: 'center',
				render: (val) => val
					? <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322' }}>Tidak Aktif</Tag>
					: <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d' }}>Aktif</Tag>,
			},
			{
				title: 'Aksi',
				key: 'aksi',
				width: 90,
				fixed: 'right',
				align: 'center',
				render: (_, row) => (
					<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
						<Tooltip title={row.deleted_at ? 'Aktifkan dulu untuk mengedit' : 'Edit'}>
							{row.deleted_at ? (
								<Button size="small" shape="circle" type="primary" ghost disabled><FormOutlined /></Button>
							) : (
								<Link to={configClass.pageUrl.form + row.id}>
									<Button size="small" shape="circle" type="primary" ghost>
										<FormOutlined />
									</Button>
								</Link>
							)}
						</Tooltip>
						{!row.deleted_at ? (
							<Tooltip title="Nonaktifkan">
								<Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}>
									<CloseSquareOutlined />
								</Button>
							</Tooltip>
						) : (
							<Tooltip title="Aktifkan kembali">
								<Button size="small" shape="circle"
									style={{ background: '#f6ffed', borderColor: '#52c41a', color: '#52c41a' }}
									onClick={() => this.showRestoreConfirm(row.id)}
								>
									<UndoOutlined />
								</Button>
							</Tooltip>
						)}
					</div>
				),
			},
		];
	}

	renderMobileCard(row) {
		return (
			<Card
				key={row.id}
				style={{
					borderRadius: 14, marginBottom: 12,
					boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
					border: '1px solid #f0f0f0', overflow: 'hidden',
				}}
				bodyStyle={{ padding: 0 }}
			>
				<div style={{
					background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
					borderBottom: '1px solid #d0dff5',
					padding: '12px 16px',
					display: 'flex', alignItems: 'center', gap: 12,
				}}>
					<div style={{
						width: 44, height: 44, borderRadius: 12,
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
					}}>
						<ClusterOutlined style={{ color: '#fff', fontSize: 20 }} />
					</div>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 15, color: '#0f2847', lineHeight: 1.3 }}>
							{row.nama}
						</div>
						<div style={{ display: 'flex', gap: 6, marginTop: 5, flexWrap: 'wrap' }}>
							<Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a', fontWeight: 600 }}>
								{row.kode || '—'}
							</Tag>
							{row.huruf && (
								<Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#f0f5ff', borderColor: '#adc6ff', color: '#2f54eb', fontWeight: 600 }}>
									{row.huruf}
								</Tag>
							)}
							<Tag color="orange" style={{ borderRadius: 20, fontSize: 11, margin: 0, fontWeight: 600 }}>
								{row.roda} roda
							</Tag>
							{row.deleted_at
								? <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322', fontWeight: 600 }}>Tidak Aktif</Tag>
								: <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d', fontWeight: 600 }}>Aktif</Tag>
							}
						</div>
					</div>
					<div style={{ display: 'flex', gap: 6 }}>
						<Tooltip title={row.deleted_at ? 'Aktifkan dulu untuk mengedit' : 'Edit'}>
							{row.deleted_at ? (
								<Button size="middle" shape="circle" type="primary" ghost disabled><FormOutlined /></Button>
							) : (
								<Link to={configClass.pageUrl.form + row.id}>
									<Button size="middle" shape="circle" type="primary" ghost><FormOutlined /></Button>
								</Link>
							)}
						</Tooltip>
						{!row.deleted_at ? (
							<Tooltip title="Nonaktifkan">
								<Button size="middle" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}>
									<CloseSquareOutlined />
								</Button>
							</Tooltip>
						) : (
							<Tooltip title="Aktifkan kembali">
								<Button size="middle" shape="circle"
									style={{ background: '#f6ffed', borderColor: '#52c41a', color: '#52c41a' }}
									onClick={() => this.showRestoreConfirm(row.id)}
								>
									<UndoOutlined />
								</Button>
							</Tooltip>
						)}
					</div>
				</div>
				<div style={{ padding: '10px 16px' }}>
					{[
						{ label: 'Plat Kuning', value: row.plat_kuning != null ? row.plat_kuning + ' %' : '—' },
						{ label: 'Rek. BBNKB', value: row.akun_bbnkb || '—' },
						{ label: 'Rek. PKB', value: row.akun_pkb || '—' },
					].map(item => (
						<div key={item.label} style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '4px 0', borderBottom: '1px solid #f5f5f5' }}>
							<Text type="secondary" style={{ fontSize: 11, flexShrink: 0, minWidth: 90 }}>{item.label}</Text>
							<Text style={{ fontSize: 12, fontFamily: 'monospace' }}>{item.value}</Text>
						</div>
					))}
				</div>
			</Card>
		);
	}

	render() {
		const { errMsg, errTitle, loadingData, dataSource, pagination, isMobile, searchText } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.data-jenis-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700;
							font-size: 12px;
							color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.data-jenis-wrap .ant-table-tbody > tr > td {
							padding: 10px 12px;
							vertical-align: middle;
						}
						.data-jenis-wrap .ant-table-tbody > tr:hover > td {
							background: #e8f0fb !important;
						}
						.data-jenis-wrap .ant-table-tbody > tr:nth-child(even) > td {
							background: #fafafa;
						}
						.data-jenis-wrap .ant-table-tbody > tr:nth-child(even):hover > td {
							background: #e8f0fb !important;
						}
						.data-jenis-wrap .row-nonaktif > td { opacity: 0.55; background: #fff9f9 !important; }
						.data-jenis-wrap .row-nonaktif:hover > td { opacity: 0.75 !important; background: #fff1f0 !important; }
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Card
					className="data-jenis-wrap"
					style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
					bodyStyle={{ padding: 0 }}
				>
					{/* ── Header ── */}
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<ClusterOutlined style={{ marginRight: 8 }} />
								{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Total {pagination.total || 0} jenis kendaraan terdaftar
								{loadingData && ' · Memuat...'}
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh data">
								<Button
									onClick={() => this.setState(
										prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }),
										() => this.getData(this.state.pagination.pageSize, 0, '')
									)}
									icon={<RedoOutlined />}
									style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								>
									{!isMobile && 'Refresh'}
								</Button>
							</Tooltip>
							<Link to={configClass.pageUrl.form}>
								<Button
									type="primary" icon={<PlusOutlined />}
									style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}
								>
									{isMobile ? 'Tambah' : 'Tambah Jenis'}
								</Button>
							</Link>
						</div>
					</div>

					{/* ── Search bar ── */}
					<div style={{
						padding: '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
					}}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
						</Text>
						<Input
							placeholder="Cari nama atau kode jenis kendaraan..."
							allowClear size="middle"
							prefix={<SearchOutlined style={{ color: '#bbb' }} />}
							style={{ borderRadius: 8, maxWidth: 360 }}
							value={searchText}
							onChange={this.handleSearchChange}
							onClear={() => this.setState(
								prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }),
								() => this.getData(this.state.pagination.pageSize, 0, '')
							)}
						/>
					</div>

					{/* ── Konten ── */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
								) : dataSource.length === 0 ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Tidak ada data</div>
								) : (
									dataSource.map(row => this.renderMobileCard(row))
								)}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current} pageSize={pagination.pageSize}
											total={pagination.total} onChange={this.handleMobilePageChange}
											showSizeChanger={false} simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								scroll={{ x: 'max-content' }}
								size="middle"
								rowClassName={(row) => row.deleted_at ? 'row-nonaktif' : ''}
								pagination={{
									current: pagination.current,
									pageSize: pagination.pageSize,
									total: pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = function (state) { return state.configReducers; }

export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(DataJenisKendaraan);
